// getShouldShowLanding.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { NEED_LANDING_COUNTRIES, PREVIEW_PRESET } from '../RemoteConfigKeys.js';

/**
 * Select should show landing page.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {boolean} will return true when user is in need landing countries and not logged in.
 */
const getShouldShowLanding = createCachedSelector(
  state => getMeData(state, 'id'),
  state => getRemoteConfigData(state, PREVIEW_PRESET) === 'blurred',
  state => {
    const userCountry = getMeData(state, 'country');
    const needLandingCountries =
      getRemoteConfigData(state, NEED_LANDING_COUNTRIES) || [];
    return needLandingCountries.includes(userCountry);
  },
  (meId, isDisplayingAgeVerify, isInNeedLandingCountries) => {
    return isDisplayingAgeVerify && isInNeedLandingCountries && !meId;
  }
)(() => 'getShouldShowLanding');

export default getShouldShowLanding;
